import { Stack } from "@mui/material";
import { Stepper } from "components/Stepper";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type TransientResponseStepperProps = {
  changeStep?: (stepNo: number) => void;
  currentStep: number;
};

export const TransientResponseStepper = ({ changeStep, currentStep }: TransientResponseStepperProps) => {
  const { t } = useTranslation();
  const steps = useMemo(
    () => [
      { name: "scenario", title: t("Execution.transient.steps.scenario") },
      { name: "configuration", title: t("Execution.transient.steps.configuration") },
    ],
    [t]
  );

  return (
    <div className="w-full bg-lds-surface-muted py-4 border-b-ds-strong">
      <Stack className="mx-auto w-fit justify-center">
        <Stepper currentStep={currentStep} onCompletedStepClick={changeStep} steps={steps} variant="inline" />
      </Stack>
    </div>
  );
};
